import type { MailboxId, MessageId, ThreadId } from "@mailflare/shared";

/**
 * Central TanStack Query key factory. Every key is structured so that broad
 * invalidations (e.g. "all messages for a mailbox") are possible without string
 * concatenation.
 */
export const queryKeys = {
  session: ["auth", "session"] as const,
  sessions: ["auth", "sessions"] as const,
  passkeys: ["auth", "passkeys"] as const,

  mailboxes: ["mailboxes"] as const,
  mailbox: (mailboxId: MailboxId) => ["mailboxes", mailboxId] as const,
  aliases: (mailboxId: MailboxId) => ["mailboxes", mailboxId, "aliases"] as const,

  messages: (mailboxId: MailboxId) => ["messages", mailboxId] as const,
  messageList: (mailboxId: MailboxId, params: Readonly<Record<string, unknown>>) =>
    ["messages", mailboxId, "list", params] as const,
  message: (messageId: MessageId) => ["message", messageId] as const,
  thread: (mailboxId: MailboxId, threadId: ThreadId) => ["threads", mailboxId, threadId] as const,

  labels: ["labels"] as const,
  search: (params: Readonly<Record<string, unknown>>) => ["search", params] as const,
  drafts: ["drafts"] as const,
  draft: (draftId: string) => ["drafts", draftId] as const,

  admin: {
    users: ["admin", "users"] as const,
    domains: ["admin", "domains"] as const,
    routingRules: ["admin", "routing-rules"] as const,
    auditLogs: ["admin", "audit-logs"] as const,
    stats: ["admin", "stats"] as const,
    dlq: ["admin", "dlq"] as const,
  },
} as const;
